import React from "react";
import { Col, Row } from "react-bootstrap";
import { Ad2CardVariantTwoBoxTitle } from "../styles/Ad2Styles";
import ReactSpeedometer from "react-d3-speedometer";
import { useTranslation } from "react-i18next";

export function EmployabilitySpeedometer({ value, title }) {
    const { t, i18n } = useTranslation();
    return <>
        <Row style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginTop:'30px',
        }}>
            <Col xs="12">
                <Ad2CardVariantTwoBoxTitle>
                    <span>{t(title)}</span>
                </Ad2CardVariantTwoBoxTitle>
            </Col>
            <Col xs="12" style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center', 
                margin: '30px 0px 30px 0px'
            }}>
                <ReactSpeedometer
                    height={130}
                    width={250}
                    minValue={0}
                    maxValue={1}
                    ringWidth={80} //thickness
                    value={parseInt(value) / 100}
                    currentValueText=""
                    needleColor="#8FBBDF"
                    segmentColors={["#0B74C3","#045694","#053D67"]}
                    valueFormat=".0%"
                    needleHeightRatio={0.7}
                    customSegmentStops={[0, 0.28, 0.73, 1.0]}
                    customSegmentLabels={[
                        {
                            text: t("Low"),
                            position: "OUTSIDE",
                            color: "#555",
                        },
                        {
                            text: t("Moderate"),
                            position: "OUTSIDE",
                            color: "#555",
                        },
                        {
                            text: t("High"),
                            position: "OUTSIDE",
                            color: "#555",
                        }
                    ]}
                />
            </Col>
        </Row>
    </>;
}